import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Paper, Typography } from '@mui/material';

import { Loading, SnakebarToaster } from '@/components';
import { CustomerHolidaysHoursDuringHolidays } from '@/features/customerHolidaysHoursDuringHolidays';
import { useSubmitNewRequestInZendeskToaster } from '@/features/customsPass/shared/hooks';
import { BoxChoice } from '@/features/sherpass/landingPage/boxChoice';
import { AddIcon, TruckIcon } from '@/utils/iconSVG';

import { stylesBoxChoice, stylesBoxContainer, stylesLandingPage } from './LandingPage.styles';
import { useGetClientAccessAsync } from './apis';
import { useLandingPage } from './hooks/useLandingPage';

export function LandingPage() {
  const { t } = useTranslation('customsPass_landingPage');
  const { handleRedirect } = useLandingPage();
  const { isLoading: isGetClientAccessLoading } = useGetClientAccessAsync();

  const { isSubmitNewRequestInZendeskSuccess, setIsSubmitNewRequestInZendeskSuccess } =
    useSubmitNewRequestInZendeskToaster();

  const handleCloseToaster = useCallback(() => {
    setIsSubmitNewRequestInZendeskSuccess(false);
  }, [setIsSubmitNewRequestInZendeskSuccess]);

  if (isGetClientAccessLoading) {
    return <Loading />;
  }

  return (
    <Box sx={stylesLandingPage}>
      {/* {clientAccessData?.clientType === CLIENT_TYPE.PROSPECT && (
        <SnakebarToaster
          withTitle
          sx={{ mt: 0 }}
          title={t('customsPass.landingPage.prospect.toaster.title')}
          icon={<SvgIcon component={ClockIcon} sx={{ fontSize: 'bodyMD.fontSize', mt: 0.25 }} />}
          severity='warning'
          contentStyles={{ color: 'grey.700' }}
          content={
            <Trans
              i18nKey={t('customsPass.landingPage.prospect.toaster.content')}
              components={{
                span: <Link component={NavLink} to='/subscribe/additional-information' />,
              }}
            />
          }
          isOpen
        />
      )} */}
      <CustomerHolidaysHoursDuringHolidays sx={{ m: '0 32px' }} />
      <Box component={Paper} elevation={4} sx={stylesBoxContainer}>
        <Typography variant='h2' sx={{ mb: 4, textAlign: 'center', fontSize: '30px', fontWeight: '600' }}>
          {t('customsPass.landingPage.title')}
        </Typography>

        <Box sx={stylesBoxChoice}>
          <BoxChoice
            icon={TruckIcon}
            handleRedirect={handleRedirect({ target: '/folders' })}
            label={t('customsPass.landingPage.currentFoldersPage')}
          />
          <BoxChoice
            icon={AddIcon}
            handleRedirect={handleRedirect({ target: '/service-offers' })}
            label={t('customsPass.landingPage.newRequestPage')}
          />
        </Box>
      </Box>
      {isSubmitNewRequestInZendeskSuccess && (
        <SnakebarToaster
          severity='success'
          content={t('customsPass.landingPage.success.toasterMessage')}
          onClose={handleCloseToaster}
          isOpen
        />
      )}
    </Box>
  );
}
